import { UI } from '@/Components/UI';
import { useTranslation } from 'react-i18next';

export const BaseDataForm = () => {
    const { t } = useTranslation(['recipes']);

    return (
        <>
            <UI.Heading level={2}>
                {t('form.baseData.heading')}
            </UI.Heading>

            <UI.Form.ImageInput
                name={'titleImage'}
                label={t('form.baseData.titleImage')}
                required />

            <UI.Form.Input
                name={'title'}
                label={t('form.baseData.title.label')}
                required
                autoFocus
                placeholder={t('form.baseData.title.placeholder')} />

            <UI.Form.Textarea
                name={'description'}
                label={t('form.baseData.description.label')}
                required
                placeholder={t('form.baseData.description.placeholder')} />

            <UI.Form.Checkbox
                name={'isPublic'}
                label={t('form.baseData.isPublic.label')}
                placeholder={t('form.baseData.isPublic.placeholder')} />

            <UI.Form.Input
                name={'difficulty'}
                label={t('form.baseData.difficulty.label')}
                type={'number'}
                required
                placeholder={t('form.baseData.difficulty.placeholder')} />

            <UI.Form.Input
                name={'servings'}
                label={t('form.baseData.servings.label')}
                type={'number'}
                required
                placeholder={t('form.baseData.servings.placeholder')} />

            <UI.Form.Input
                name={'preparationTime'}
                label={t('form.baseData.preparationTime.label')}
                type={'number'}
                required
                placeholder={t('form.baseData.preparationTime.placeholder')} />
        </>
    );
};
